const normalize_role = (role) => {
    if (!role) {
        return '';
    }

    const roleMap = {
        doer: 'Doer',
        scout: 'Scout',
        knight: 'Knight',
        knights: 'Knight',
        merchant: 'Merchant',
        baron: 'Baron',
        king: 'King',
        admin: 'Admin'
    };

    const normalizedRole = String(role).trim();
    const normalizedKey = normalizedRole
        .toLowerCase()
        .replace(/^role[_:-]/, '')
        .replace(/^doitforme[_:-]/, '');

    return roleMap[normalizedKey] || normalizedRole;
};

const role_values = (roles) => {
    if (!roles) {
        return [];
    }

    if (Array.isArray(roles)) {
        return roles.flatMap((role) => role_values(role));
    }

    if (typeof roles === 'string') {
        return roles.split(',').map((role) => role.trim());
    }

    if (typeof roles === 'object') {
        return [
            ...role_values(roles.roles),
            ...role_values(roles.memberRoles),
            ...role_values(roles.authRoles),
            ...role_values(roles.role),
            ...role_values(roles.companyRole),
            ...role_values(roles.name),
            ...role_values(roles.value)
        ];
    }

    return [];
};

export const normalize_roles = (roles) => {
    const normalizedRoles = role_values(roles)
        .map((role) => normalize_role(role))
        .filter(Boolean);

    return [...new Set(normalizedRoles)];
};

export const hasRole = (roleToCheck, roles) => {
    const normalizedRoles = normalize_roles(roles);
    const normalizedRoleToCheck = normalize_role(roleToCheck);

    return normalizedRoles.includes(normalizedRoleToCheck);
};
